const accordions = document.querySelectorAll(".accordion-title");
accordions.forEach(accordion => {
  accordion.addEventListener("click", e => {
    e.preventDefault();
    const item = e.target.closest(".accordion-item");
    const content = item.querySelector(".accordion-content");

    if (content.classList.contains("hidden")) {
      content.classList.remove("hidden");
      accordion.innerHTML = "Hide nutritional info";
    } else {
      content.classList.add("hidden");
      accordion.innerHTML = "View nutritional info";
    }
  });
});
